<template>
    <Products v-if="activeView=='products' && isLoaded"
        @setActiveView="setActiveView"
        @setChildCategory="setChildCategory"
        @cartUpdated="setCart"
        :categories="categories"
        :regions="regions"
        :cart="cart"
        :parentCategory="parentCategory"
        :childCategory="childCategory"
        :sharableCartId="sharableCartId"
    ></Products>
    <Product v-if="activeView=='product' && isLoaded"
        @setActiveView="setActiveView"
        @cartUpdated="setCart"
        :parentCategory="parentCategory"
        :childCategory="childCategory"
        :productId="productId"
        :sharableCartId="sharableCartId"
        ></Product>
    <Checkout v-if="activeView=='checkout' && isLoaded"
        @setActiveView="setActiveView"
        @cartUpdated="setCart"
        @setPlacedOrderData="setPlacedOrderData"
        @setSharableCartId="setSharableCartId"
        :categories="categories"
        :regions="regions"
        :parentCategory="parentCategory"
        :childCategory="childCategory"
        :cart="cart"
        :parentDomain="parentDomain"
        :sharableCartId="sharableCartId"></Checkout>
    <Thankyou v-if="activeView=='thankyou' && isLoaded"
        @setActiveView="setActiveView"
        @cartUpdated="setCart"
        @setSharableCartId="setSharableCartId"
        :categories="categories"
        :regions="regions"
        :parentCategory="parentCategory"
        :childCategory="childCategory"
        :placedOrderData="placedOrderData"
        :sharableCartId="sharableCartId"></Thankyou>
    <div v-if="parentCategory && parentCategory.gcma" className="w-full text-right pr-4 pb-10 text-sm">
        {{ parentCategory.gcma }}
    </div>
    <div v-if="orderFormIsVisible && parentCategory && parentCategory.id == 1" class="w-full px-4">
        <p class="max-w-full text-sm">
            <span class="font-bold">Dataskydd.</span>&nbsp;I samband med din anmälan för nyhetsbrev gäller följande. Hälso- och sjukvårdsanställdas personuppgifter behandlas (1) under kontroll
            av Pfizer AB, org.nr 556059-6255&nbsp;och Bristol-Myers Squibb Aktiebolag, 556092-9886, som var för sig är självständigt personuppgiftsansvariga och delas internationellt
            inom Pfizer-koncernen och Bristol-Myers Squibb-koncernen och med tjänsteleverantörer med lämpliga skyddsåtgärder vidtagna; (2) för att interagera och komma i kontakt med dig;
            för att bedriva vår verksamhet så att våra rättsliga skyldigheter efterlevs, för statistikändamål eller för att tillgodose våra berättigade intressen i att upprätthålla vår
            verksamhet; och (3) för att tillhandahålla dig med marknadsförings- och kommersiell kommunikation. Dina personuppgifter samlas in från dig av någon av dina kontakter med
            Pfizer eller Bristol-Myers Squibb och från IT-företag som tillhandahåller informationstjänster inom hälso- och sjukvårdssektorn, allmänt tillgängliga källor för yrkesrelaterad
            information och partners för gemensam marknadsföring. Om du önskar att kontakta oss eller Pfizers eller Bristol-Myers Squibbs dataskyddsombud, <a href="mailto:EUDPO@BMS.com" class="underline">EUDPO@BMS.com</a>, för att få mer
            information rörande vårt respektive integritetsarbete eller för att begära att få utöva någon rättighet hänförligt till dataskydd (inklusive begäran om att få invända mot vårt
            respektive berättigade intresse eller om att återkalla ett samtycke, om tillämpligt), vänligen se Pfizers Integritetsmeddelande för hälso- och sjukvårdsanställda inom EES på
            <a href="https://privacycenter.pfizer.com/sv/hcp" target="_blank" class="underline">https://privacycenter.pfizer.com/sv/hcp</a> och Bristol-Myers Squibbs Integritetspolicy på
            <a href="https://www.bms.com/se/privacy-policy.html" target="_blank" class="underline">https://www.bms.com/se/privacy-policy.html</a> i enlighet med Bristol-Myers Squibbs bindande
            företagsbestämmelser som du kan läsa här: <a href="https://www.bms.com/assets/bms/us/en-us/pdf/binding-corporate-rules.pdf" target="_blank" class="underline">https://www.bms.com/assets/bms/us/en-us/pdf/binding-corporate-rules.pdf</a>
        </p>
        <p class="max-w-full mt-4 pb-4 text-sm">
            Bristol-Myers Squibb AB, tel. 08-704 71 00, <a href="https://www.bms.com/se" target="_blank" class="underline">www.bms.com/se</a>, Pfizer AB, Sweden, tel. 08-550 520 00,
            <a href="https://www.pfizer.se" target="_blank" class="underline">www.pfizer.se</a>, Personuppgiftsfrågor: <a href="mailto:info.sweden@pfizer.com" class="underline">info.sweden@pfizer.com</a>
        </p>
    </div>
</template>
<script>
import { onMounted, ref }   from 'vue'
import Products             from './Products'
import Product              from './Product'
import Checkout             from './Checkout'
import Thankyou             from './Thankyou'

export default {
    components: {
        Products,
        Product,
        Checkout,
        Thankyou
    },
    props: {
        properties: {
            type: [Object, null],
            default: null,
        }
    },
    methods: {
        setActiveView(view, args = []) {
            if (view == 'checkout') {
                window.dispatchEvent(new CustomEvent('pfizershop', {
                    detail: {
                        action: 'proceed-to-checkout'
                    }
                }));
            }

            if (args['product'] != undefined ) {
                this.productId = Number(args['product'].id);
            }

            window.scrollTo(0, 0);
            this.activeView = view

            window.dispatchEvent(new CustomEvent('pfizershop', {
                detail: {
                    currentView: view,
                    productUrl: args['product'] != undefined ? this.getProductUrl(args['product'], null, null) : null,
                    productName: args['product'] != undefined ? args['product'].name : null,
                }
            }));
        },
        setChildCategory(category) {
            this.childCategory = category

            window.dispatchEvent(new CustomEvent('pfizershop', {
                detail: {
                    action: 'child-category-selected',
                    childCategory: category
                }
            }));
        },
        getProductUrl(product, parentCategory, childCategory) {
            // Create a nifty URL for the product
				let productName = product.name
					.replace(/\s+/g, '-')
					.replace(/[áàäâãåÁÀÄÂÃÅ]/g, 'a')
					.replace(/[óòöôõÓÒÖÔÕ]/g, 'o')
					.replace(/[éèëêÉÈËÊ]/g, 'e')
					.replace(/[úùüûÚÙÜÛ]/g, 'u')
					.replace(/[íìïîÍÌÏÎ]/g, 'i')
					.replace(/[^a-zA-Z0-9-]/g, '')
					.toLowerCase();

            let url = `${product.id}-${productName}`;

            if (parentCategory) {
                url += `/${parentCategory.id}`;
            }

            if (childCategory) {
                url += `/${childCategory.id}`;
            }

			return url;
        },
        setCart(cart) {
            this.cart = cart
            localStorage.setItem('pf-cart', JSON.stringify(cart));

            if (this.sharableCartId) {
                fetch(process.env.MIX_API_URL+'/cart/saveSharableCart', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ cart: cart, unique_id: this.sharableCartId }),
                });

                if (!localStorage.getItem('pf-sharable-cart-id')) {
                    localStorage.setItem('pf-sharable-cart-id', this.sharableCartId);
                }
            }
        },
        setSharableCartId(id) {
            this.sharableCartId = id

            if (!id) {
                localStorage.removeItem('pf-sharable-cart-id');
            } else {
                localStorage.setItem('pf-sharable-cart-id', id);
            }
        },
        setPlacedOrderData(data) {
            this.placedOrderData = data
        },
    },
    
    setup(props) {
        const activeView =  ref('products')
        const categories = ref([])
        const regions = ref([])
        const parentCategory = ref(null)
        const childCategory = ref(null)
        const isLoaded = ref(false)
        const cart = ref([])
        const sharableCartId = ref(null);
        const placedOrderData = ref([])
        const productId = ref(0)
        const orderFormIsVisible = ref(false)
        const parentDomain = ref('')

        const getCart = () => {
            let cart = localStorage.getItem('pf-cart') ? JSON.parse(localStorage.getItem('pf-cart')) : '[]';
            return cart
        }

        onMounted(async () => {
            if (!props.properties) {
                var urlParams = new URLSearchParams(document.currentScript.src.split('?').pop());
                var category = urlParams.get('category');
                var parent_category = urlParams.get('parent_category');

                fetch(process.env.MIX_API_URL+'/api/shop?parent_category=' + parent_category + (category ? '&category=' + category : ''), {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                    }).then((response) => response.json()).then((data) => {
                        regions.value = data.regions
                        categories.value = data.categories
                        parentCategory.value = data.parentCategory
                        childCategory.value = data.childCategory
                    }).finally(() => {
                        isLoaded.value = true
                    })
            } else {
                regions.value = props.properties.regions
                categories.value = props.properties.categories
                parentCategory.value = props.properties.parentCategory
                childCategory.value = props.properties.childCategory
                isLoaded.value = true
            }

            cart.value = getCart();

            // Add event listener for show-order-form
            window.addEventListener('show-order-form', () => {
                orderFormIsVisible.value = true;
            });

            var urlParams = document.currentScript && !document.currentScript.src.includes('app.js') ?
                new URLSearchParams(document.currentScript.src.split('?').pop()) :
                new URLSearchParams(document.location.search);

            if (urlParams.get('parent_domain')) {
                parentDomain.value = urlParams.get('parent_domain');
            }

            if (urlParams.get('pid')) {
                productId.value = Number(urlParams.get('pid'));
                activeView.value = 'product';
            }
            else if (urlParams.get('activeView')) {
                if (urlParams.get('activeView') == 'checkout' || urlParams.get('activeView') == 'varukorg' || urlParams.get('cid') != null) {
                    activeView.value = 'checkout';
                }
            }

            const hasCartIdInUrl = (() => {
                return urlParams.get('cid') || null;
            })();

            if (hasCartIdInUrl) {
                await fetch(process.env.MIX_API_URL+'/cart/getSharableCart/'+hasCartIdInUrl).then(response => response.json()).then(data => {
                    if (data.status === 'success') {
                        localStorage.setItem('pf-cart', JSON.stringify(data.cart.items));
                        cart.value = data.cart.items;

                        if (hasCartIdInUrl.endsWith('-')) {
                            sharableCartId.value = null;
                            localStorage.removeItem('pf-sharable-cart-id');
                        } else {
                            sharableCartId.value = data.cart.unique_id;
                        }

                    } else {
                        sharableCartId.value = null;
                        localStorage.removeItem('pf-sharable-cart-id');
                        // alert('Den delade varukorgen du försöker hämta är inte längre tillgänglig.');
                    }
                })
                activeView.value = 'checkout';

            } else if (localStorage.getItem('pf-sharable-cart-id')) {
                sharableCartId.value = localStorage.getItem('pf-sharable-cart-id');
            }

            setInterval(() => {
                if (sharableCartId.value) {
                    fetch(process.env.MIX_API_URL+'/cart/getSharableCart/'+sharableCartId.value).then(response => response.json()).then(data => {
                        if (data.status === 'success') {
                            localStorage.setItem('pf-cart', JSON.stringify(data.cart.items));
                            cart.value = data.cart.items;
                            sharableCartId.value = data.cart.unique_id.endsWith('-') ? null : data.cart.unique_id;
                        } else {
                            sharableCartId.value = null;
                            // alert('Den delade varukorgen du försöker hämta är inte längre tillgänglig.');
                        }
                    })
                }
            }, 5000);
        })

        return {
            isLoaded,
            activeView,
            categories,
            regions,
            parentCategory,
            childCategory,
            cart,
            sharableCartId,
            placedOrderData,
            productId,
            parentDomain,
            orderFormIsVisible
        }
    }
}
</script>
<style>
html, body {
    background-color: #ffffff !important;
}
</style>